import { Platform } from 'react-native';
import DeviceInfo from 'react-native-device-info';
import Config from 'react-native-config';

const KEY = {
  CODEPUSH: {
    ANDROID: {
      DEV: 'fCrpuIe1o4zkr96wIjnsWMXsYw6KRlSKinbpe',
      PROD: '8zmD9PT4yMbeMnVPfAor389CYFzTRlSKinbpe'
    },
    IOS: {
      DEV: 'sZRp45hSX0mKZ2XiasRYIcR5Y2OGRlSKinbpe',
      PROD: 'MyVzoO7gXDy4WLnzMtgtODaxfcKHRlSKinbpe'
    }
  },
  ONE_SIGNAL: '770a21bb-eb5c-4254-8052-bb0ea11ddac8'
};

const IS_ANDROID = Platform.OS === 'android';
const platformCodepushKey = Platform.OS === 'ios' ? 'IOS' : 'ANDROID';
const { CODEPUSH_KEY_ANDROID, CODEPUSH_KEY_IOS } = Config;
const CODEPUSH_KEY = platformCodepushKey === 'IOS' ? CODEPUSH_KEY_IOS : CODEPUSH_KEY_ANDROID;
const IS_DEV_BUILD = CODEPUSH_KEY === KEY.CODEPUSH[platformCodepushKey].DEV;

export default {
  NAME: DeviceInfo.getApplicationName(),
  PATCH: '221026_1126',
  FACEBOOK_MESSENGER_URL: 'https://m.me/quanlybanhangaseller',
  WEB_VERSION_URL: 'https://aseller.vn',
  WEB_VERSION_URL_BACKUP: 'https://web.aseller.vn',
  VERSION: DeviceInfo.getVersion(), // Không gọi cái này trong logevent của firebase kẻo ngu người
  URL: IS_ANDROID ? 'https://play.google.com/store/apps/details?id=' + DeviceInfo.getBundleId() : 'itms-apps://itunes.apple.com/us/app/id1490758477',
  IS_IOS: Platform.OS === 'ios',
  IS_ANDROID,
  IS_WEB: Platform.OS === 'web',
  DEVICE_VERSION: DeviceInfo.getSystemVersion(),
  IAP_PACKAGE: {
    REMOVE_ADS: IS_ANDROID ? 'com.utilityxgitapp.sale.management.removeads' : 'com.dstudio.qlbh.removeads',
    ALL: [
      { id: IS_ANDROID ? 'com.utilityxgitapp.sale.management.subs1m' : 'com.dstudio.qlbh.sub1month', languageKey: 'package1M', isSub: true, amount: 1, sku: 'sub1month' },
      { id: IS_ANDROID ? 'com.utilityxgitapp.salemanagement.subs3m' : 'com.dstudio.qlbh.sub3month', languageKey: 'package3M', isSub: true, amount: 3, sku: 'sub3month' },
      { id: IS_ANDROID ? 'com.utilityxgitapp.salemanagement.subs6m' : 'com.dstudio.qlbh.sub6month', languageKey: 'package6M', isSub: true, amount: 6, sku: 'sub6month' },
      {
        id: IS_ANDROID ? 'com.utilityxgitapp.sale.management.subs1y' : 'com.dstudio.qlbh.subs1year',
        languageKey: 'package1Y',
        isSub: true,
        amount: 12,
        isRecommend: true,
        sku: 'subs1year'
      },
      { id: IS_ANDROID ? 'com.utilityxgitapp.sale.management.pack6m' : 'com.dstudio.qlbh.pack6m', languageKey: 'package6M', amount: 6, sku: 'pack6m' },
      { id: IS_ANDROID ? 'com.utilityxgitapp.sale.management.pack1y' : 'com.dstudio.qlbh.pack1y', languageKey: 'package1Y', amount: 12, isRecommend: true, sku: 'pack1y' },
      { id: IS_ANDROID ? 'com.utilityxgitapp.sale.management.pack5yn' : 'com.dstudio.qlbh.pack5yn', languageKey: 'package5Y', amount: 5 * 12, isRecommend: true, sku: 'pack5yn' },
      { id: IS_ANDROID ? 'com.utilityxgitapp.sale.management.pack5y' : 'com.dstudio.qlbh.pack5y', languageKey: 'package5Y', amount: 5 * 12, isRecommend: true, sku: 'pack5y' },
      { id: IS_ANDROID ? 'com.utilityxgitapp.sale.management.pack10y' : 'com.dstudio.qlbh.pack10y', languageKey: 'package10Y', amount: 10 * 12, isRecommend: true, sku: 'pack10y' },
      { id: 'trial', languageKey: 'trial', isSub: true, amount: 0, sku: 'trial' }
    ],
    STAFF_UPGRADE: [
      { id: IS_ANDROID ? 'com.utilityxgitapp.sale.staff.pack1y' : 'com.dstudio.qlbh.staff.pack1y', languageKey: 'packageStaff1Y', isOther: true, sku: 'staff.pack1y' }
    ],
    WAREHOUSE_UPGRADE: [
      {
        id: IS_ANDROID ? 'com.utilityxgitapp.sale.warehouse.pack1y' : 'com.dstudio.qlbh.warehouse.pack1y',
        languageKey: 'packageWarehouse1Y',
        isOther: true,
        sku: 'warehouse.pack1y'
      }
    ]
  },
  IAP_PACKAGE1: {
    REMOVEADS: IS_ANDROID ? 'com.utilityxgitapp.sale.management.removeads' : 'com.dstudio.qlbh.removeads',
    PRO: IS_ANDROID ? 'com.utilityxgitapp.sale.management.proversion' : 'com.dstudio.qlbh.proversion',
    SUBS: [
      IS_ANDROID ? 'com.utilityxgitapp.sale.management.subs1m' : 'com.dstudio.qlbh.sub1month',
      IS_ANDROID ? 'com.utilityxgitapp.sale.management.subs1y' : 'com.dstudio.qlbh.subs1year'
    ]
  },
  DEV_EMAIL: 'asellerteam@gmail.com',
  IS_DEV_BUILD,
  KEY,
  NOT_SUPPORT_USER_IDS: []
};
